import { render, staticRenderFns } from "./IntroducitonContent1.vue?vue&type=template&id=df2c6f3a&scoped=true"
import script from "./IntroducitonContent1.vue?vue&type=script&lang=js"
export * from "./IntroducitonContent1.vue?vue&type=script&lang=js"
import style0 from "./IntroducitonContent1.vue?vue&type=style&index=0&id=df2c6f3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2c6f3a",
  null
  
)

export default component.exports